import { render, staticRenderFns } from "./LogicDetail.vue?vue&type=template&id=b4e08dd6&scoped=true&"
import script from "./LogicDetail.vue?vue&type=script&lang=js&"
export * from "./LogicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e08dd6",
  null
  
)

export default component.exports